export default __webpack_public_path__ + "static/media/capital-empregado-ok.48eac60a.svg";